import { render, staticRenderFns } from "./threeDView.vue?vue&type=template&id=ac049906&scoped=true&"
import script from "./threeDView.vue?vue&type=script&lang=js&"
export * from "./threeDView.vue?vue&type=script&lang=js&"
import style0 from "./threeDView.vue?vue&type=style&index=0&id=ac049906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac049906",
  null
  
)

export default component.exports